import { StockDocument } from "../models"
import { FromReferencePayload, InventoryAdjustmentPayload, PatchPayload, PostPayload, QuickCreatePayload } from "../services"

export const ACTION_TYPES = {
    FETCH : "FETCH_STOCK_DOCUMENT" as const,
    FETCH_SUCCESS: "FETCH_STOCK_DOCUMENT_SUCCESS" as const,
    PATCH_PRICING_TABLE_ITEM:"PATCH_PRICING_TABLE_ITEM" as const,
    PATCH: "PATCH_STOCK_DOCUMENT" as const,
    CREATE: "CREATE_STOCK_DOCUMENT" as const,
    CREATE_FROM_REFERENCE: "CREATE_FROM_REFERENCE_STOCK_DOCUMENT" as const,
    DELETE: "DELETE_STOCK_DOCUMENT" as const,
    CLEAR: "CLEAR_STOCK_DOCUMENT" as const,
    UNARCHIVE: "UNARCHIVE_STOCK_DOCUMENT" as const,
    MARK_AS_DONE: "MARK_AS_DONE_STOCK_DOCUMENT" as const,
    ADJUST_INVENTORY: "INVENTORY_ADJUSTMENT" as const,
    RELOAD: "RELOAD_STOCK_DOCUMENT" as const,
    QUICK_CREATE_STOCK_DOCUMENT: "QUICK_CREATE_STOCK_DOCUMENT" as const,
}

export type Actions =
    | { type: typeof ACTION_TYPES.FETCH, payload: string }
    | { type: typeof ACTION_TYPES.PATCH_PRICING_TABLE_ITEM, payload: string }
    | { type: typeof ACTION_TYPES.FETCH_SUCCESS, payload: StockDocument }
    | { type: typeof ACTION_TYPES.PATCH, payload: PatchPayload }
    | { type: typeof ACTION_TYPES.CREATE, payload: PostPayload }
    | { type: typeof ACTION_TYPES.CREATE_FROM_REFERENCE, payload: FromReferencePayload }
    | { type: typeof ACTION_TYPES.DELETE }
    | { type: typeof ACTION_TYPES.CLEAR }
    | { type: typeof ACTION_TYPES.UNARCHIVE }
    | { type: typeof ACTION_TYPES.MARK_AS_DONE }
    | { type: typeof ACTION_TYPES.ADJUST_INVENTORY, payload: InventoryAdjustmentPayload}
    | { type: typeof ACTION_TYPES.RELOAD }
    | { type: typeof ACTION_TYPES.QUICK_CREATE_STOCK_DOCUMENT, payload: QuickCreatePayload }




// WEBPACK FOOTER //
// ./src/state/inventory/stockdocument/actions/types.ts